import { AxiosError } from 'axios'

import { ErrorResponse } from '../store'

export const INVALID_PHONE_KEY = 'INVALID_PHONE'
export const INVALID_PHONE_MESSAGE = 'Invalid phone number'

export const getApiErrorKey = (
    error: AxiosError<ErrorResponse>,
): string | undefined => error.response?.data?.key

export const isInvalidPhoneError = (
    error: unknown,
): error is AxiosError<ErrorResponse> => {
    const err = error as AxiosError<ErrorResponse>
    return getApiErrorKey(err) === INVALID_PHONE_KEY
}

export const getInvalidPhoneMessage = (error: unknown): string => {
    const err = error as AxiosError<ErrorResponse>
    return err.response?.data?.message ?? INVALID_PHONE_MESSAGE
}

export const applyInvalidPhoneFieldErrors = (options: {
    phone: string
    cellPhone: string
    setPhoneError: (value: boolean) => void
    setCellPhoneError: (value: boolean) => void
}): void => {
    const { phone, cellPhone, setPhoneError, setCellPhoneError } = options
    setPhoneError(phone.trim().length > 0)
    setCellPhoneError(cellPhone.trim().length > 0)
}
